import React from "react";

import paymentGateway from "../../assets/images/payment-gateway.png";

const PackageLesson = () => {
  return (
    <>
      <section class="keyzi_content--wrapper">
        <div class="container-fluid px-3 px-md-5">
          <div class="keyzi_content--inner ">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="card mb-4 p-4">
                  <h4>Package Test/Lesson</h4>
                  <p>Includes</p>
                  <ul>
                    <li>The driving Instructor on test day</li>
                    <li>Use of driving school car while out on your test</li>
                    <li>Pick up &amp; drop off at your chosen destination</li>
                    <li>45-minute lesson just before your test starts.</li>
                  </ul>
                  <p>Price - $225</p>
                  <p>
                    Note - All learners are required to book their own driving
                    test with the relevant Licensing Authority.
                  </p>
                  <img
                    src={paymentGateway}
                    alt="Payment Methods"
                    class="payment-methods img-fluid"
                  />
                  <a href="#find-instructor" class="btn btn-primary w-100">
                    Book Lessons Now
                  </a>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="card p-4">
                  <h4>Locality Pricing &amp; Discounts</h4>
                  <p>
                    Keyzi sets a lesson price, but instructors may choose to
                    discount or adjust this price based on discounts for
                    multiple lessons, suburbs, and Test/Lesson Packages.
                  </p>
                  <ul>
                    <li>1-5 hrs - $ p/hour</li>
                    <li>6-9 hrs - $ p/hour</li>
                    <li>10 hrs + - $ p/hour</li>
                  </ul>
                  <p>Lesson Duration is typically 1 or 2 hours</p>
                  <p>
                    Note - Each Keyzi driving instructor has their own special
                    locality pricing range displayed near the instructors'
                    photo.
                  </p>
                  <a href="#find-instructor" class="btn btn-primary w-100">
                    Book Lessons Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PackageLesson;
